/**
 * 商品企画メンテナンス画面Output用VOクラス
 *
 * @export KYMW0900OutputModel
 * @class KYMW0900OutputModel
 */
export class KYMW0900OutputModel {

  // Ｐコード
  public pCode: string = <string>'';
}
